import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  filter,
  getCategories,
  getColors,
  getCompanies,
  getMaximumPrice,
  sortData,
} from "../helper/filters";
import { useDispatch, useSelector } from "react-redux";
import { setFilteredProducts } from "../actions";
import { currency } from "../helper";

const FilterProducts = ({ sortType, setSortType }) => {
  const { filteredProducts, allProducts } = useSelector(
    (state) => state.products
  );
  const dispatch = useDispatch();
  const maximumPrice = getMaximumPrice(allProducts);

  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [company, setCompany] = useState("");
  const [color, setColor] = useState("");
  const [price, setPrice] = useState(maximumPrice);
  const [freeShipping, setFreeShipping] = useState(false);

  const companies = getCompanies(allProducts);
  const categories = getCategories(allProducts);
  const colors = getColors(allProducts);

  const handleClearFilters = () => {
    setName("");
    setCategory("");
    setCompany("");
    setColor("");
    setPrice(maximumPrice);
    setFreeShipping(false);
  };

  useEffect(() => {
    const newProducts = filter(
      { name, category, company, color, price, shipping: freeShipping },
      allProducts
    );
    const sortedProducts = sortData(newProducts, sortType);
    console.log(sortedProducts);
    dispatch(setFilteredProducts(sortedProducts));
  }, [name, category, color, company, price, freeShipping]);

  return (
    <Wrapper>
      <div className="search-name">
        <span>
          <i className="fas fa-search"></i>
        </span>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value.trim())}
          placeholder="search"
        />
      </div>
      <div className="category">
        <h4>Category</h4>
        <select
          onChange={(e) => setCategory(e.target.value)}
          name="category"
          id="categories"
        >
          <option value="">All</option>
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>
      <div className="company">
        <h4>Company</h4>
        <select
          name="company"
          id="companies"
          onChange={(e) => setCompany(e.target.value)}
        >
          <option value="">All</option>
          {companies.map((company, index) => (
            <option key={index} value={company}>
              {company}
            </option>
          ))}
        </select>
      </div>
      <div className="colors">
        <h4>Colors</h4>
        <div>
          <p
            style={color === "" ? { borderBottom: "2px solid black" } : {}}
            onClick={() => setColor("")}
          >
            All
          </p>
          {colors.map((item, index) => (
            <span
              key={index}
              className={color === item ? "active" : ""}
              onClick={() => setColor(item)}
              style={{ backgroundColor: item }}
            ></span>
          ))}
        </div>
      </div>
      <div className="price">
        <h4>Price</h4>
        <p>
          {currency} {price}
        </p>
        <input
          type="range"
          name="price"
          id="price"
          min="0"
          max={maximumPrice}
          value={price}
          onChange={(e) => setPrice(parseInt(e.target.value))}
        />
      </div>
      <div className="free-shipping">
        <p>Free Shipping</p>
        <input
          type="checkbox"
          name="free-shipping"
          id=""
          value={freeShipping}
          checked={freeShipping}
          onChange={() => setFreeShipping(!freeShipping)}
        />
      </div>
      <div className="clear">
        <button
          className="btn"
          type="reset"
          onClick={() => handleClearFilters()}
        >
          Clear Filters
        </button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: sticky;
  top: 20px;
  > div {
    margin-bottom: 10px;
  }
  > .search-name {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: var(--color-primary-2);
    color: var(--color-black-2);
    border-radius: 5px;
    > input {
      border: none;
      background-color: var(--color-primary-2);
      width: 100%;
    }
    > span {
      margin-right: 7px;
    }
  }
  .company,
  .category {
    width: 60%;
    > h4 {
      margin-bottom: 5px;
    }
    > select {
      border: none;
      width: 100%;
      background-color: var(--color-primary-2);
      padding: 2px;
      border-radius: 5px;
    }
  }
  > .colors {
    > div {
      display: flex;
      align-items: center;
      > p {
        cursor: pointer;
      }
      > span {
        height: 15px;
        width: 15px;
        border-radius: 15px;
        margin-left: 10px;
        cursor: pointer;
      }
      > .active {
        box-shadow: 0 0 2px 1px;
      }
    }
  }
  > .free-shipping {
    display: flex;
    align-items: center;
    > input {
      margin-left: 10px;
    }
  }
  @media screen and (max-width: 600px) {
    flex-direction: row;
    > div {
      margin: 5px 2.5%;
    }
    > .clear {
      width: 100%;
      > button {
        width: 100%;
      }
    }
    .colors,
    .price,
    .category,
    .company {
      width: 45%;
    }
    .colors {
      > div {
        > span {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
`;

export default FilterProducts;
